/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TableDataRef,
  TableDataRef$inboundSchema,
  TableDataRef$Outbound,
  TableDataRef$outboundSchema,
} from "./tabledataref.js";

/**
 * The row of the table.
 */
export type TableRowConfig = {
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * The name of the row
   */
  name?: string | undefined;
  /**
   * The references to the row
   */
  refs: Array<TableDataRef>;
};

/** @internal */
export const TableRowConfig$inboundSchema: z.ZodType<
  TableRowConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: types.string(),
  name: types.optional(types.string()),
  refs: z.array(TableDataRef$inboundSchema),
});
/** @internal */
export type TableRowConfig$Outbound = {
  id: string;
  name?: string | undefined;
  refs: Array<TableDataRef$Outbound>;
};

/** @internal */
export const TableRowConfig$outboundSchema: z.ZodType<
  TableRowConfig$Outbound,
  z.ZodTypeDef,
  TableRowConfig
> = z.object({
  id: z.string(),
  name: z.string().optional(),
  refs: z.array(TableDataRef$outboundSchema),
});

export function tableRowConfigToJSON(tableRowConfig: TableRowConfig): string {
  return JSON.stringify(TableRowConfig$outboundSchema.parse(tableRowConfig));
}
export function tableRowConfigFromJSON(
  jsonString: string,
): SafeParseResult<TableRowConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TableRowConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TableRowConfig' from JSON`,
  );
}
